import { getBuyButtonConfig } from '../utils/commonEntitlements';

export const LOGO_KIT_CONFIG = {
  hero: {
    buyBox: [
      {
        bulletPoints: [
          { title: 'productPage.logoKit.buyBox.bulletPoint1' },
          { title: 'productPage.logoKit.buyBox.bulletPoint2' },
          { title: 'productPage.logoKit.buyBox.bulletPoint3' },
        ],
        productName: 'productPage.logoKit.buyBox.productName',
        veloCta: {
          displayVeloCta: true,
          promptMessageId: 'productPage.logoKit.buyBox.veloCta.prompt',
          topic: 'logo-kit',
        },
        interactService: {
          service: 'logo_kit',
        },
      },
    ],
    headerPicture: {
      src: '/s2/raster/logokit-packaging-branded.png',
      alt: 'productPage.logoKit.heroPicture.altText',
    },
    headline: 'productPage.logoKit.page.headline',
    partnerLogo: {},
    partnerReviewBlanks: [],
    subheader: 'productPage.logoKit.page.subheader',
  },
  showCase: {
    title: 'productPage.logoKit.showCase.title',
    stylesItem: {
      variantItem: 'outlined',
    },
    items: [
      {
        image: '/s2/raster/customcut-logo-framed.png',
        alt: 'productPage.logoKit.showCase.alt',
      },
      {
        image: '/s2/raster/maverick-logo-framed.png',
        alt: 'productPage.logoKit.showCase.alt',
      },
      {
        image: '/s2/raster/rems-logo-framed.png',
        alt: 'productPage.logoKit.showCase.alt',
      },
      {
        image: '/s2/raster/desertwolf-logo-framed.png',
        alt: 'productPage.logoKit.showCase.alt',
      },
    ],
  },
  benefit: {
    title: 'productPage.logoKit.valueProp.title',
    items: [
      {
        icon: '/s2/material-icons/rocketlaunchrounded.svg',
        title: 'productPage.logoKit.valueProp.propTitle1',
        description: 'productPage.logoKit.valueProp.shortCopy1',
      },
      {
        icon: '/s2/material-icons/workspacepremiumrounded.svg',
        title: 'productPage.logoKit.valueProp.propTitle2',
        description: 'productPage.logoKit.valueProp.shortCopy2',
      },
      {
        icon: '/s2/material-icons/dashboardrounded.svg',
        title: 'productPage.logoKit.valueProp.propTitle3',
        description: 'productPage.logoKit.valueProp.shortCopy3',
      },
    ],
  },
  highlight: {
    icon: '/s2/material-icons/mylocationrounded.svg',
    title: 'productPage.logoKit.topFeature.title',
    subheader: 'productPage.logoKit.topFeature.subheader',
    image: '/s2/raster/logobuilder-allfiletypes.png',
    alt: 'productPage.logoKit.topFeature.altText',
  },
  howItWorks: {
    title: 'productPage.logoKit.howItWorks.title',
    items: [
      {
        title: 'productPage.logoKit.howItWorks.step1',
        description: 'productPage.logoKit.howItWorks.shortDescription1',
      },
      {
        title: 'productPage.logoKit.howItWorks.step2',
        description: 'productPage.logoKit.howItWorks.shortDescription2',
      },
      {
        title: 'productPage.logoKit.howItWorks.step3',
        description: 'productPage.logoKit.howItWorks.shortDescription3',
      },
    ],
    hasNumber: true,
    hasDivider: false,
    hasMobileImage: true,
    video: '7442knekhn',
  },
  socialProof: {
    image: '/s2/raster/logobuildersample-blocks-contained.png',
    alt: 'productPage.logoKit.testimonial.altText',
    testimonial: {
      quote: 'productPage.logoKit.testimonial.quote',
      source: 'productPage.logoKit.testimonial.source',
      author: 'productPage.logoKit.testimonial.author',
    },
  },
  whatsIncluded: {
    title: 'productPage.logoKit.whatsIncluded.title',
    items: [
      {
        title: 'productPage.logoKit.whatsIncluded.item1',
        description: 'productPage.logoKit.whatsIncluded.item1ShortDescription',
      },
      {
        title: 'productPage.logoKit.whatsIncluded.item2',
        description: 'productPage.logoKit.whatsIncluded.item2ShortDescription',
      },
      {
        title: 'productPage.logoKit.whatsIncluded.item3',
        description: 'productPage.logoKit.whatsIncluded.item3ShortDescription',
      },
      {
        title: 'productPage.logoKit.whatsIncluded.item4',
        description: 'productPage.logoKit.whatsIncluded.item4ShortDescription',
      },
    ],
    image: '/s2/raster/owner-open-sign-happy.png',
    alt: 'productPage.logoKit.whatsIncluded.altText',
    hasNumber: false,
    hasDivider: true,
    hasMobileImage: false,
  },
  faqs: {
    title: 'productPage.logoKit.frequentlyAskedQuestions.title',
    items: [
      {
        question: 'productPage.logoKit.frequentlyAskedQuestions.faq1',
        answer: 'productPage.logoKit.frequentlyAskedQuestions.faqAnswer1',
      },
      {
        question: 'productPage.logoKit.frequentlyAskedQuestions.faq2',
        answer: 'productPage.logoKit.frequentlyAskedQuestions.faqAnswer2',
      },
      {
        question: 'productPage.logoKit.frequentlyAskedQuestions.faq3',
        answer: 'productPage.logoKit.frequentlyAskedQuestions.faqAnswer3',
      },
      {
        question: 'productPage.logoKit.frequentlyAskedQuestions.faq4',
        answer: 'productPage.logoKit.frequentlyAskedQuestions.faqAnswer4',
      },
    ],
  },
  assistance: {
    title: 'productPage.logoKit.needAssistance.title',
    getInTouch: 'productPage.logoKit.needAssistance.getInTouch',
    actions: 'productPage.logoKit.needAssistance.actions',
  },
  getBuyButtonConfig: (entitlements, service) =>
    getBuyButtonConfig({
      entitlements,
      service,
      ctaText: 'productPage.logoKit.buyBox.buttonLabel',
      ownedCtaText: 'productPage.common.buyBox.alreadyOwnedLabel',
    }),
};
